<template>
  <loader v-if="ticket === null"></loader>
  <div v-else class="flex-1">
    <page-title
      :heading="`تیکت #${ticket.serial} - ${ticket.title}`"
      subHeading="اطلاعات تیکت در زیر قابل مشاهده است."
      buttonTitle="بازگشت"
      @onClickButton="onClickButton"
    />
    <vs-row class="details-container">
      <vs-col vs-lg="3" vs-sm="12" vs-xs="12" class="details-card">
        <details-card :ticket="ticket" @reply="replyTicket" />
      </vs-col>
      <vs-col vs-lg="9" vs-sm="12" vs-xs="12">
        <message-box
          ref="messageBoxRef"
          :ticketId="ticket.id"
          @onTicketReplied="onTicketReplied"
        />
        <messages :messages="ticket.messages" />
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PageTitle from "../../../components/pageTitle/PageTitle.vue";
import Messages from "./Messages.vue";
import DetailsCard from "./DetailsCard.vue";
import providerApiService from "../../../services/api/ProviderApiService";
import MessageBox from "./MessageBox.vue";

export default {
  name: "Details.vue",
  components: { Messages, DetailsCard, PageTitle, MessageBox },
  data() {
    return {
      ticket: null,
    };
  },
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
  mounted() {
    this.getTicketDetails();
  },
  methods: {
    getTicketDetails() {
      const ticketId = this.$route.params.id;
      providerApiService
        .getTicketDetails(this.currentProvider.id, ticketId)
        .then((result) => (this.ticket = result.data));
    },
    onClickButton() {
      this.$router.back();
    },
    replyTicket() {
      this.$refs["messageBoxRef"].toggleMessageBoxVisibility();
    },
    onTicketReplied(ticket) {
      this.ticket = ticket;
    },
  },
};
</script>

<style lang="scss">
.details-container {
  display: flex;
  align-items: flex-start;
  width: 100%;
  max-width: 1253px;
  margin: 0 auto;

  .details-card {
    position: sticky;
    top: 80px;

    @media (max-width: 900px) {
      position: inherit;
    }
  }
}
</style>

